:host {
  display: block;
}

.tab-content {
  display: none;
}

.tab-content.selected {
  display: block;
}
